// extracted by mini-css-extract-plugin
module.exports = {"IconList":"IconList_IconList__IF4zv","IsTransparent":"IconList_IsTransparent__2hv2c","isCentered":"IconList_isCentered__1wOSS"};